import { inject, Injectable } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { NavigationService } from '@services/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class BookingGuard {
  authService = inject(AuthService);
  navigationService = inject(NavigationService);

  canActivate(): boolean {
    const currentUser = this.authService.currentUser;

    if (!currentUser.enable_booking) {
      this.navigationService.navigate('rides');
      return false;
    }

    return true;
  }
}
